// Legal.js
import React from "react";
import { useTheme as useAppTheme } from "../contexts/ThemeContext";

export default function PrivacyPolise({
  companyName = "Zakazuj",
  contactEmail = "system@zakazuj.com",
  updateDate = "06-09-2025",
}) {
  const { isDarkMode } = useAppTheme();

  const s = {
    wrap: {
      maxWidth: 860,
      margin: "0 auto",
      padding: "32px 20px",
      lineHeight: 1.6,
      color: isDarkMode ? "#e6e6e6" : "#333333",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, "Apple Color Emoji","Segoe UI Emoji"',
      background: "transparent",
    },
    h1: { fontSize: 32, margin: "0 0 8px", color: isDarkMode ? "#ffffff" : "#000000", fontWeight: 800 },
    h2: {
      fontSize: 22,
      margin: "28px 0 10px",
      color: isDarkMode ? "#ffffff" : "#000000",
      fontWeight: 700,
    },
    p: { margin: "10px 0" },
    small: { opacity: 0.75, fontSize: 14, marginBottom: 24, display: "block" },
    li: { margin: "6px 0" },
    box: {
      background: isDarkMode ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)",
      border: isDarkMode ? "1px solid rgba(255,255,255,0.12)" : "1px solid rgba(0,0,0,0.12)",
      borderRadius: 12,
      padding: 16,
      margin: "16px 0",
    },
    link: { color: isDarkMode ? "#93c5fd" : "#2563eb", textDecoration: "none" },
    divider: {
      margin: "40px 0",
      borderBottom: isDarkMode ? "2px solid rgba(255,255,255,0.2)" : "2px solid rgba(0,0,0,0.2)",
    },
  };

  return (
    <main style={s.wrap}>
      {/* ------------------ TERMS ------------------ */}
      <h1 style={s.h1}>Uslovi korišćenja</h1>
      <span style={s.small}>Poslednje ažuriranje: {updateDate}</span>

      <p style={s.p}>
        Dobrodošli u <strong>{companyName}</strong>. Korišćenjem ove aplikacije
        slažete se sa sledećim uslovima. Ako se ne slažete, nemojte koristiti
        aplikaciju.
      </p>

      <h2 style={s.h2}>1. Prihvatanje uslova</h2>
      <p style={s.p}>
        Korišćenjem potvrđujete da imate najmanje 16 godina ili dozvolu
        roditelja/staratelja.
      </p>

      <h2 style={s.h2}>2. Opis usluge</h2>
      <p style={s.p}>
        {companyName} omogućava zakazivanje termina i upravljanje uslugama.
        Funkcionalnosti se mogu menjati bez prethodne najave.
      </p>

      <h2 style={s.h2}>3. Korisnički nalozi</h2>
      <ul>
        <li style={s.li}>
          Odgovorni ste za tačnost podataka i čuvanje lozinke.
        </li>
        <li style={s.li}>Obavezni ste da prijavite neovlašćen pristup.</li>
        <li style={s.li}>
          Nalog može biti suspendovan u slučaju kršenja uslova.
        </li>
      </ul>

      <h2 style={s.h2}>4. Zakazivanja i otkazivanja</h2>
      <div style={s.box}>
        <p style={s.p}>
          Politike zakazivanja i otkazivanja određuju pružaoci usluga.{" "}
          {companyName} nije odgovoran za promene termina ili kvalitet usluge
          trećih lica.
        </p>
      </div>

      <h2 style={s.h2}>5. Dozvoljeno korišćenje</h2>
      <ul>
        <li style={s.li}>
          Zabranjena zloupotreba aplikacije (spam, hakerski napadi).
        </li>
        <li style={s.li}>Zabranjeno kopiranje i redistribucija bez dozvole.</li>
      </ul>

      <h2 style={s.h2}>6. Intelektualna svojina</h2>
      <p style={s.p}>
        Sav sadržaj aplikacije je vlasništvo {companyName} ili licenciran od
        trećih strana.
      </p>

      <h2 style={s.h2}>7. Privatnost</h2>
      <p style={s.p}>
        Lični podaci se obrađuju u skladu sa Politikom privatnosti u nastavku.
      </p>

      <h2 style={s.h2}>8. Odricanje od odgovornosti</h2>
      <p style={s.p}>
        Aplikacija se pruža „takva kakva jeste“. {companyName} ne garantuje
        neprekidan rad i nije odgovoran za štetu nastalu korišćenjem.
      </p>

      <h2 style={s.h2}>9. Izmene uslova</h2>
      <p style={s.p}>
        Zadržavamo pravo izmene uslova. Nastavak korišćenja znači da prihvatate
        izmene.
      </p>

      <h2 style={s.h2}>10. Kontakt</h2>
      <p style={s.p}>
        Za pitanja kontaktirajte nas na{" "}
        <a href={`mailto:${contactEmail}`} style={s.link}>
          {contactEmail}
        </a>
        .
      </p>

      <div style={s.divider} />

      {/* ------------------ PRIVACY ------------------ */}
      <h1 style={s.h1}>Politika privatnosti</h1>
      <span style={s.small}>Poslednje ažuriranje: {updateDate}</span>

      <p style={s.p}>
        Ova Politika privatnosti objašnjava kako {companyName} prikuplja,
        koristi i čuva vaše podatke.
      </p>

      <h2 style={s.h2}>1. Podaci koje prikupljamo</h2>
      <ul>
        <li style={s.li}>Podaci o nalogu (ime, email, telefon).</li>
        <li style={s.li}>Podaci o zakazivanjima i uslugama koje koristite.</li>
        <li style={s.li}>Tehnički podaci (uređaj, IP adresa, kolačići).</li>
      </ul>

      <h2 style={s.h2}>2. Kako koristimo podatke</h2>
      <p style={s.p}>
        Podatke koristimo za obezbeđivanje usluga, unapređenje aplikacije,
        komunikaciju sa vama i zaštitu bezbednosti sistema.
      </p>

      <h2 style={s.h2}>3. Deljenje podataka</h2>
      <p style={s.p}>
        Ne delimo lične podatke sa trećim stranama, osim kada je to neophodno za
        pružanje usluge, po zakonskoj obavezi ili uz vašu saglasnost.
      </p>

      <h2 style={s.h2}>4. Bezbednost</h2>
      <p style={s.p}>
        Preduzimamo mere zaštite podataka, ali ne možemo garantovati apsolutnu
        sigurnost.
      </p>

      <h2 style={s.h2}>5. Vaša prava</h2>
      <ul>
        <li style={s.li}>Pravo na uvid i ispravku podataka.</li>
        <li style={s.li}>Pravo na brisanje i ograničavanje obrade.</li>
        <li style={s.li}>Pravo da povučete saglasnost.</li>
      </ul>

      <h2 style={s.h2}>6. Čuvanje podataka</h2>
      <p style={s.p}>
        Podatke čuvamo onoliko dugo koliko je potrebno za pružanje usluge ili po
        zakonskim obavezama.
      </p>

      <h2>7. Brisanje naloga i podataka</h2>
      <p>
        Korisnici imaju pravo da u svakom trenutku zatraže brisanje svog naloga
        i svih povezanih podataka. Za brisanje naloga, pošaljite zahtev na
        sledeću adresu e-pošte:
        <a href="mailto:system@zakazujme.com">system@zakazujme.com</a>.
      </p>

      <h2 style={s.h2}>8. Izmene politike</h2>
      <p style={s.p}>
        Politika privatnosti može biti ažurirana. Sve izmene objavljujemo na
        ovoj stranici.
      </p>

      <h2 style={s.h2}>9. Kontakt</h2>
      <p style={s.p}>
        Ako imate pitanja o privatnosti, pišite na{" "}
        <a href={`mailto:${contactEmail}`} style={s.link}>
          {contactEmail}
        </a>
        .
      </p>
    </main>
  );
}
